"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelocityHistoryChart = void 0;
var react_1 = __importDefault(require("react"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var get_1 = __importDefault(require("lodash/get"));
var LineAndBar_1 = __importDefault(require("@CommonFrontend/Charts/ComposedChart/LineAndBar"));
var DateConverter_1 = require("Reports/Utils/DateConverter");
var CalculateTimePeriod_1 = require("Reports/Utils/CalculateTimePeriod");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var METRIC_COLOR_MAPPING = {
    "pageVelocity.pageCycleTimes.averageClose": tokens_1.palette.yellow500,
    "pageVelocity.averagePageValue": tokens_1.palette.orange300,
    "pageVelocity.closeAcceptRate": tokens_1.palette.green300,
};
var METRIC_LABEL_FORMATER_MAPPING = {
    "pageVelocity.pageCycleTimes.averageClose": function (days) { return "".concat(Math.trunc(days), "d"); },
    "pageVelocity.averagePageValue": function (value, currency) {
        return (0, FormatCurrency_1.formatAbbreviatedCurrency)(value, currency, 0, true);
    },
    "pageVelocity.closeAcceptRate": function (rate) { return "".concat(Math.trunc(rate * 100), "%"); },
};
function VelocityHistoryChart(_a) {
    var data = _a.data, granularity = _a.granularity, filters = _a.filters, selectedTimePeriod = _a.selectedTimePeriod, selectedCurrency = _a.selectedCurrency;
    if ((0, isEmpty_1.default)(data) || (0, isEmpty_1.default)(filters))
        return null;
    var chartData = getDataForVelocityChart(data, granularity, filters, selectedTimePeriod, selectedCurrency);
    return (react_1.default.createElement(LineAndBar_1.default, { data: chartData, colors: {
            lineColor: tokens_1.palette.purple400,
            barColors: filters.map(function (key) { return METRIC_COLOR_MAPPING[key]; }),
        }, barChartProportion: 0.333, config: {
            yAxis: {
                label: "Sales velocity",
                minTicks: 4,
                maxTicks: 4,
                tickColor: tokens_1.palette.purple400,
                tickFont: tokens_1.tokens.font.ui,
                tickLetterSpacing: "1px",
            },
            xAxis: {
                legend: "Sales velocity",
            },
        } }));
}
exports.VelocityHistoryChart = VelocityHistoryChart;
function getDataForVelocityChart(data, granularity, filters, selectedTimePeriod, selectedCurrency) {
    var periodStart = (0, CalculateTimePeriod_1.calculateTimePeriod)(selectedTimePeriod).periodStart;
    var selectedPeriodStartLabel = (0, DateConverter_1.getChartDateLabel)(periodStart, granularity);
    return data.map(function (velocityData) {
        var time = velocityData.time, metrics = velocityData.metrics;
        var pageVelocity = metrics.pageVelocity;
        var velocity = pageVelocity.velocity;
        var xAxisName = (0, DateConverter_1.getChartDateLabel)(time, granularity);
        return {
            xAxisName: xAxisName,
            data: {
                line: velocity,
                bars: filters.map(function (key) { return (0, get_1.default)(metrics, key, 0); }),
                labels: filters.map(function (key) { return METRIC_LABEL_FORMATER_MAPPING[key]((0, get_1.default)(metrics, key, 0), selectedCurrency); }),
            },
            isSelected: xAxisName === selectedPeriodStartLabel,
        };
    });
}
